<h2 mat-dialog-title>{{title()}}</h2>
<mat-dialog-content>
  {{ question() }}
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton mat-dialog-close (click)="onNoClick()">No</button>
  <button matButton mat-dialog-close cdkFocusInitial (click)="onOkCLick()">Ok</button>
</mat-dialog-actions>
